import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { IPhoneMockup } from './IPhoneMockup';
import { FloatingElements } from './FloatingElements';
const TALLY_URL = 'https://tally.so/r/Ek57zL';
export function WaitlistHero() {
  return <section id="waitlist-hero" className="relative min-h-screen flex items-center overflow-hidden bg-[#0F1B2D] pt-28 pb-16 lg:pt-32" data-id="element-146">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden" data-id="element-147">
        <div className="absolute -top-[20%] -left-[10%] h-[600px] w-[600px] rounded-full bg-[#E8531E]/10 blur-[100px] animate-pulse" data-id="element-148" />
        <div className="absolute top-[40%] -right-[10%] h-[500px] w-[500px] rounded-full bg-[#1A2744]/50 blur-[100px]" data-id="element-149" />

        {/* Grid Pattern */}
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5" data-id="element-150" />

        {/* Animated Orbs */}
        <motion.div animate={{
        x: [0, 50, 0],
        y: [0, 30, 0]
      }} transition={{
        duration: 20,
        repeat: Infinity,
        ease: 'linear'
      }} className="absolute top-1/4 left-1/4 w-64 h-64 bg-blue-500/10 rounded-full blur-[80px]" data-id="element-151" />
        <motion.div animate={{
        x: [0, -30, 0],
        y: [0, -50, 0]
      }} transition={{
        duration: 15,
        repeat: Infinity,
        ease: 'linear'
      }} className="absolute bottom-1/3 right-1/4 w-96 h-96 bg-[#E8531E]/5 rounded-full blur-[100px]" data-id="element-152" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 z-10 w-full" data-id="element-153">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-8" data-id="element-154">
          {/* Left Content */}
          <div className="flex-1 text-center lg:text-left" data-id="element-155">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="inline-flex items-center rounded-full border border-white/10 bg-white/5 px-4 py-1.5 backdrop-blur-sm mb-8 mx-auto lg:mx-0" data-id="element-156">
              <span className="flex h-2 w-2 rounded-full bg-[#E8531E] mr-2 animate-pulse" data-id="element-157"></span>
              <span className="text-sm font-medium text-slate-300" data-id="element-158">
                Coming Soon to Nigeria
              </span>
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="text-5xl font-extrabold tracking-tight text-white sm:text-6xl lg:text-7xl mb-6" data-id="element-159">
              Own Property in Nigeria <br data-id="element-160" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-slate-400" data-id="element-161">
                From Anywhere
              </span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="text-lg text-slate-400 leading-relaxed max-w-2xl mx-auto lg:mx-0 mb-10" data-id="element-162">
              Join the waitlist for VeriProp — the secure, transparent platform
              helping Nigerians in the diaspora invest in verified properties
              back home.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} data-id="element-163">
              <a href={TALLY_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center rounded-lg bg-[#E8531E] text-white hover:bg-[#CC4A15] font-semibold h-14 px-8 text-lg transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#E8531E] shadow-lg shadow-orange-900/20 hover:scale-105 active:scale-95" data-id="element-164">
                Join the Waitlist <ArrowRight className="ml-2 h-5 w-5" data-id="element-165" />
              </a>
            </motion.div>
          </div>

          {/* Right Content - iPhone Mockup */}
          <div className="flex-1 relative w-full max-w-[400px] lg:max-w-none flex justify-center lg:justify-end" data-id="element-166">
            <FloatingElements data-id="element-167" />
            <motion.div animate={{
            y: [0, -15, 0]
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="relative z-10" data-id="element-168">
              <IPhoneMockup data-id="element-169" />
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}